"use strict";

require("core-js/modules/es.array.filter");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _jakteCore = require("@drawbotics/jakte-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var JaktePlugin =
/*#__PURE__*/
function () {
  function JaktePlugin(Jakte, pluginKey, config) {
    var _this$listeners;

    _classCallCheck(this, JaktePlugin);

    this.listeners = (_this$listeners = {}, _defineProperty(_this$listeners, _jakteCore.JakteEvents.INIT, []), _defineProperty(_this$listeners, _jakteCore.JakteEvents.UPDATE, []), _this$listeners);
    this.Jakte = Jakte;
    this.pluginKey = pluginKey;
    this.config = config;
  }

  _createClass(JaktePlugin, [{
    key: "willInit",
    value: function willInit() {
      return true;
    }
  }, {
    key: "init",
    value: function init() {
      return true;
    }
  }, {
    key: "setData",
    value: function setData(data) {
      var newData = typeof data === 'function' ? data(this.Jakte.dumpCollected(this.pluginKey)) : data;
      this.Jakte.setPluginData(this.pluginKey, newData);
      this.triggerListeners(_jakteCore.JakteEvents.UPDATE);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventKey, listener) {
      if (eventKey == null) {
        throw new Error('Missing eventKey when adding listener');
      }

      this.listeners[eventKey].push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventKey, listener) {
      if (eventKey == null) {
        throw new Error('Missing eventKey when remove listener');
      }

      this.listeners[eventKey] = this.listeners[eventKey].filter(function (l) {
        return l === listener;
      });
    }
  }, {
    key: "triggerListeners",
    value: function triggerListeners(eventKey) {
      var listeners = this.listeners[eventKey];
      listeners.forEach(function (listener) {
        return listener();
      });
    }
  }]);

  return JaktePlugin;
}();

var _default = JaktePlugin;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-plugin/lib/JaktePlugin.js
// module id = 550
// module chunks = 0